import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  GET_PATIENT_EXPORT_TEMPLATE_FAILURE,
  GET_PATIENT_EXPORT_TEMPLATE_REQUEST,
  GET_PATIENT_EXPORT_TEMPLATE_SUCCESS,
  GET_PATIENT_EXPORT_TEMPLATE_LOADING,
} = patientAction;

function* getPatientExportCsv(payload: any): SagaReturnType<any> {
  try {    
    yield put({ type: GET_PATIENT_EXPORT_TEMPLATE_LOADING });
    const response = yield call(patientService.getPatientExportTemplate, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_EXPORT_TEMPLATE_SUCCESS, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_EXPORT_TEMPLATE_FAILURE, payload: error });
  }
}

function* getPatientExportCsvSaga() {
  yield takeEvery(GET_PATIENT_EXPORT_TEMPLATE_REQUEST, getPatientExportCsv);
}

export default getPatientExportCsvSaga;
